export default {
  card: {
    main: '0 2px 15px 0 rgba(0, 0, 0, 0.2)',
  },
  tooltip: {
    main: '0 8px 24px 0 rgba(0, 0, 0, 0.15)',
  },
};
